<template>
  <v-dialog
    :value="showDialog"
    max-width="400"
    @update:return-value="closeDialog"
  >
    <v-card>
      <v-card-title>
        Confirm logout
        <v-spacer />
        <v-btn icon @click="closeDialog">
          <v-icon color="grey"> mdi-close-circle-outline </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="body-1">
        Are you sure you want to logout?
      </v-card-text>
      <v-card-actions class="px-6 pb-6 pt-0">
        <v-row justify="center" class="ma-0">
          <v-col cols="3">
            <v-btn color="error" tile @click="logout"> Yes </v-btn>
          </v-col>
          <v-col cols="3">
            <v-btn color="success" tile @click="closeDialog"> No </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmLogoutDialog',
  props: ['showDialog'],
  methods: {
    closeDialog() {
      this.$emit('onClose')
    },
    logout() {
      this.closeDialog()
      this.$store.dispatch('firebaseLogout')
      this.$router.push('/')
    },
  },
}
</script>

<style scoped></style>
